import type { FC, ReactNode } from 'react'

import { topics } from '@/constants/landing'

export const Marquee: FC = (): ReactNode => {
    const items = [...topics, ...topics]

    return (
        <section aria-label="Topics covered" className='relative border-y border-hairline bg-white py-6'>
            <div className='overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]'>
                <ul className='marquee-track flex w-max'>
                    {items.map((topic, index) => (
                        <li
                            key={`${topic}-${index}`}
                            aria-hidden={index >= topics.length}
                            className='flex shrink-0 items-center gap-6 pr-6 text-[15px] font-medium tracking-[-0.01em] text-muted-foreground sm:gap-8 sm:pr-8 sm:text-base'
                        >
                            <span className='whitespace-nowrap'>{topic}</span>
                            <span aria-hidden='true' className='size-1.5 rounded-full bg-border' />
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}
